import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild } from "@angular/core";
import { ScriptLoaderService } from '../../_services';

@Component({
    selector: 'app-boolean-switch',
    templateUrl: './boolean-switch.component.html'
})

export class BooleanSwitchComponent implements AfterViewInit {
    @Output() stateChanged = new EventEmitter();
    @Input() texts = {
        on: "Encendido",
        off: "Apagado"
    };
    @Input() colorOn = "brand";
    @ViewChild('switch') switch;
    constructor(protected _script: ScriptLoaderService) { }
    ngAfterViewInit() {
        this._script.loadScripts('app-boolean-switch',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-switch.js']);
        $(this.switch.nativeElement).on('switchChange.bootstrapSwitch', (event, state) => {
            this.stateChanged.emit(state);
        });
    }
    setState(state) {
        ($(this.switch.nativeElement) as any).bootstrapSwitch('state', state);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/boolean-switch/boolean-switch.component.ts